import { render, staticRenderFns } from "./deleteItemRelease.vue?vue&type=template&id=897bc800"
import script from "./deleteItemRelease.vue?vue&type=script&lang=js"
export * from "./deleteItemRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports